import React, { Fragment as _, useContext } from 'react';
import { Box } from 'theme-ui';

const AssessmentIntroduction = ({ children, ...props }) => {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        background: 'red',
      }}
    >
      <h1>Assessment Introduction</h1>
    </Box>
  );
};

export default AssessmentIntroduction;
